import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import type { TopInvitor } from "@/services/api";

export function InvitationRanking({ data }: { data: TopInvitor[] }) {
  const max = data.reduce((m, d) => Math.max(m, d.invitedCount), 0) || 1;

  return (
    <Card>
      <CardHeader>
        <CardTitle>邀请排行榜</CardTitle>
        <CardDescription>邀请注册用户数 Top 10</CardDescription>
      </CardHeader>
      <CardContent>
        {data.length > 0 ? (
          <div className="space-y-3">
            {data.map((item, idx) => (
              <div key={item.userId} className="flex items-center gap-3">
                <span className="w-8 text-sm font-medium text-muted-foreground">
                  #{idx + 1}
                </span>
                <span className="w-32 truncate text-sm">{item.username || `用户 ${item.userId}`}</span>
                <div className="flex-1">
                  <div className="h-5 rounded bg-primary/15">
                    <div
                      className="h-5 rounded bg-primary"
                      style={{ width: `${(item.invitedCount / max) * 100}%` }}
                    />
                  </div>
                </div>
                <span className="w-12 text-right text-sm font-medium">
                  {item.invitedCount} 人
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="h-[200px] flex items-center justify-center text-muted-foreground">
            暂无邀请数据
          </div>
        )}
      </CardContent>
    </Card>
  );
}
